import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('@sankarah/commo-feature-main').then(
        (m) => m.commoFeatureMainRoutes,
      ),
  },
];
